import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {ComplexFilter} from "@vesta/vos-types/modules/workspaceLevel/domain/ComplexFilter";
import {getEvent_ColumnValues, getEventContainerColumnValues} from "~/utilities/apis/api";

type TemplateEventsColumnValuesQueryArgs = {
    workspaceId: Uuid;
    eventTemplateId: Uuid;
    columnId: string;
    intellsysBaseUrl: string;
    accessToken: string;
    filters?: ComplexFilter;
};

type EventContainerColumnValuesQueryArgs = {
    workspaceId: Uuid;
    /** Event-container (journey) template id required by column-values. */
    eventContainerTemplateId: Uuid;
    columnId: string;
    intellsysBaseUrl: string;
    accessToken: string;
    filters?: ComplexFilter;
};

async function fetchEventContainerColumnValuesFromApi(
    args: EventContainerColumnValuesQueryArgs,
): Promise<Array<string>> {
    const eventContainerColumnValuesResult = await getEventContainerColumnValues({
        workspaceId: args.workspaceId,
        columnId: args.columnId,
        intellsysBaseUrl: args.intellsysBaseUrl,
        accessToken: args.accessToken,
        templateId: args.eventContainerTemplateId,
        filters: args.filters,
    });
    if (eventContainerColumnValuesResult.success !== true) {
        throw eventContainerColumnValuesResult.error;
    }
    return eventContainerColumnValuesResult.data;
}

async function fetchEventColumnValuesFromApi(
    args: TemplateEventsColumnValuesQueryArgs,
): Promise<Array<string>> {
    const eventColumnValuesResult = await getEvent_ColumnValues({
        workspaceId: args.workspaceId,
        columnId: args.columnId,
        intellsysBaseUrl: args.intellsysBaseUrl,
        accessToken: args.accessToken,
        templateId: args.eventTemplateId,
        filters: args.filters,
    });
    if (eventColumnValuesResult.success !== true) {
        throw eventColumnValuesResult.error;
    }
    return eventColumnValuesResult.data;
}

/** Distinct Event Container column values via the Event Containers column-values API. */
export async function getEventContainerColumnValuesFromTemplateEvents(
    args: EventContainerColumnValuesQueryArgs,
): Promise<Array<string>> {
    return fetchEventContainerColumnValuesFromApi(args);
}

/** Distinct event column values via the Ottopilot events column-values API. */
export async function getEventColumnValuesFromTemplateEvents(
    args: TemplateEventsColumnValuesQueryArgs,
): Promise<Array<string>> {
    return fetchEventColumnValuesFromApi(args);
}
